/**
 * Propally Agent API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import Agent from './Agent';
import AssessmentProposal from './AssessmentProposal';
import InvestmentProposal from './InvestmentProposal';
import MatchingType from './MatchingType';
import SalesNoteCompleteReasonEnum from './SalesNoteCompleteReasonEnum';
import SalesNoteProspectLankEnum from './SalesNoteProspectLankEnum';
import SalesNoteStatusEnum from './SalesNoteStatusEnum';
import User from './User';
import UserOfferSourceAnalysisItemSourceEnum from './UserOfferSourceAnalysisItemSourceEnum';
import UserOfferSourceCategoryEnum from './UserOfferSourceCategoryEnum';
import UserProposal from './UserProposal';

/**
 * The ProposalMatching model module.
 * @module model/ProposalMatching
 * @version 1.0.0
 */
class ProposalMatching {
    /**
     * Constructs a new <code>ProposalMatching</code>.
     * @alias module:model/ProposalMatching
     */
    constructor() { 
        
        ProposalMatching.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>ProposalMatching</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/ProposalMatching} obj Optional instance to populate.
     * @return {module:model/ProposalMatching} The populated <code>ProposalMatching</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new ProposalMatching();

            if (data.hasOwnProperty('id')) {
                obj['id'] = ApiClient.convertToType(data['id'], 'Number');
            }
            if (data.hasOwnProperty('discarded_at')) {
                obj['discarded_at'] = ApiClient.convertToType(data['discarded_at'], 'Date');
            }
            if (data.hasOwnProperty('is_invalid')) {
                obj['is_invalid'] = ApiClient.convertToType(data['is_invalid'], 'Boolean');
            }
            if (data.hasOwnProperty('agent_id')) {
                obj['agent_id'] = ApiClient.convertToType(data['agent_id'], 'Number');
            }
            if (data.hasOwnProperty('user_id')) {
                obj['user_id'] = ApiClient.convertToType(data['user_id'], 'Number');
            }
            if (data.hasOwnProperty('assessment_proposal_id')) {
                obj['assessment_proposal_id'] = ApiClient.convertToType(data['assessment_proposal_id'], 'Number');
            }
            if (data.hasOwnProperty('investment_proposal_id')) {
                obj['investment_proposal_id'] = ApiClient.convertToType(data['investment_proposal_id'], 'Number');
            }
            if (data.hasOwnProperty('is_manual_match')) {
                obj['is_manual_match'] = ApiClient.convertToType(data['is_manual_match'], 'Boolean');
            }
            if (data.hasOwnProperty('is_agent_read')) {
                obj['is_agent_read'] = ApiClient.convertToType(data['is_agent_read'], 'Boolean');
            }
            if (data.hasOwnProperty('created_at')) {
                obj['created_at'] = ApiClient.convertToType(data['created_at'], 'Date');
            }
            if (data.hasOwnProperty('updated_at')) {
                obj['updated_at'] = ApiClient.convertToType(data['updated_at'], 'Date');
            }
            if (data.hasOwnProperty('user_registered_at')) {
                obj['user_registered_at'] = ApiClient.convertToType(data['user_registered_at'], 'Date');
            }
            if (data.hasOwnProperty('first_preferred_contact_date')) {
                obj['first_preferred_contact_date'] = ApiClient.convertToType(data['first_preferred_contact_date'], 'Date');
            }
            if (data.hasOwnProperty('first_preferred_contact_time_slot')) {
                obj['first_preferred_contact_time_slot'] = ApiClient.convertToType(data['first_preferred_contact_time_slot'], 'String');
            }
            if (data.hasOwnProperty('second_preferred_contact_date')) {
                obj['second_preferred_contact_date'] = ApiClient.convertToType(data['second_preferred_contact_date'], 'Date');
            }
            if (data.hasOwnProperty('second_preferred_contact_time_slot')) {
                obj['second_preferred_contact_time_slot'] = ApiClient.convertToType(data['second_preferred_contact_time_slot'], 'String');
            }
            if (data.hasOwnProperty('agent')) {
                obj['agent'] = Agent.constructFromObject(data['agent']);
            }
            if (data.hasOwnProperty('user')) {
                obj['user'] = User.constructFromObject(data['user']);
            }
            if (data.hasOwnProperty('investment_proposal')) {
                obj['investment_proposal'] = InvestmentProposal.constructFromObject(data['investment_proposal']);
            }
            if (data.hasOwnProperty('assessment_proposal')) {
                obj['assessment_proposal'] = AssessmentProposal.constructFromObject(data['assessment_proposal']);
            }
            if (data.hasOwnProperty('user_proposal')) {
                obj['user_proposal'] = UserProposal.constructFromObject(data['user_proposal']);
            }
            if (data.hasOwnProperty('is_contract_applied')) {
                obj['is_contract_applied'] = ApiClient.convertToType(data['is_contract_applied'], 'Boolean');
            }
            if (data.hasOwnProperty('matching_type')) {
                obj['matching_type'] = MatchingType.constructFromObject(data['matching_type']);
            }
            if (data.hasOwnProperty('user_matching_type')) {
                obj['user_matching_type'] = ApiClient.convertToType(data['user_matching_type'], 'String');
            }
            if (data.hasOwnProperty('matching_counts')) {
                obj['matching_counts'] = ApiClient.convertToType(data['matching_counts'], 'Number');
            }
            if (data.hasOwnProperty('matched_count_sum')) {
                obj['matched_count_sum'] = ApiClient.convertToType(data['matched_count_sum'], 'Number');
            }
            if (data.hasOwnProperty('matched_count_user')) {
                obj['matched_count_user'] = ApiClient.convertToType(data['matched_count_user'], 'Number');
            }
            if (data.hasOwnProperty('matched_count_investment')) {
                obj['matched_count_investment'] = ApiClient.convertToType(data['matched_count_investment'], 'Number');
            }
            if (data.hasOwnProperty('matched_count_assessment')) {
                obj['matched_count_assessment'] = ApiClient.convertToType(data['matched_count_assessment'], 'Number');
            }
            if (data.hasOwnProperty('matched_count_manual')) {
                obj['matched_count_manual'] = ApiClient.convertToType(data['matched_count_manual'], 'Number');
            }
            if (data.hasOwnProperty('prospect_lank')) {
                obj['prospect_lank'] = SalesNoteProspectLankEnum.constructFromObject(data['prospect_lank']);
            }
            if (data.hasOwnProperty('status')) {
                obj['status'] = SalesNoteStatusEnum.constructFromObject(data['status']);
            }
            if (data.hasOwnProperty('complete_reason')) {
                obj['complete_reason'] = SalesNoteCompleteReasonEnum.constructFromObject(data['complete_reason']);
            }
            if (data.hasOwnProperty('progress')) {
                obj['progress'] = ApiClient.convertToType(data['progress'], 'String');
            }
            if (data.hasOwnProperty('appointment_date')) {
                obj['appointment_date'] = ApiClient.convertToType(data['appointment_date'], 'Date');
            }
            if (data.hasOwnProperty('sales_note_updated_at')) {
                obj['sales_note_updated_at'] = ApiClient.convertToType(data['sales_note_updated_at'], 'Date');
            }
            if (data.hasOwnProperty('user_offer_source_category')) {
                obj['user_offer_source_category'] = UserOfferSourceCategoryEnum.constructFromObject(data['user_offer_source_category']);
            }
            if (data.hasOwnProperty('user_offer_source')) {
                obj['user_offer_source'] = UserOfferSourceAnalysisItemSourceEnum.constructFromObject(data['user_offer_source']);
            }
            if (data.hasOwnProperty('learning_completed_count')) {
                obj['learning_completed_count'] = ApiClient.convertToType(data['learning_completed_count'], 'Number');
            }
            if (data.hasOwnProperty('learning_progress_rate')) {
                obj['learning_progress_rate'] = ApiClient.convertToType(data['learning_progress_rate'], 'Number');
            }
            if (data.hasOwnProperty('is_target')) {
                obj['is_target'] = ApiClient.convertToType(data['is_target'], 'Boolean');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>ProposalMatching</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>ProposalMatching</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['first_preferred_contact_time_slot'] && !(typeof data['first_preferred_contact_time_slot'] === 'string' || data['first_preferred_contact_time_slot'] instanceof String)) {
            throw new Error("Expected the field `first_preferred_contact_time_slot` to be a primitive type in the JSON string but got " + data['first_preferred_contact_time_slot']);
        }
        // ensure the json data is a string
        if (data['second_preferred_contact_time_slot'] && !(typeof data['second_preferred_contact_time_slot'] === 'string' || data['second_preferred_contact_time_slot'] instanceof String)) {
            throw new Error("Expected the field `second_preferred_contact_time_slot` to be a primitive type in the JSON string but got " + data['second_preferred_contact_time_slot']);
        }
        // validate the optional field `agent`
        if (data['agent']) { // data not null
          Agent.validateJSON(data['agent']);
        }
        // validate the optional field `user`
        if (data['user']) { // data not null
          User.validateJSON(data['user']);
        }
        // validate the optional field `investment_proposal`
        if (data['investment_proposal']) { // data not null
          InvestmentProposal.validateJSON(data['investment_proposal']);
        }
        // validate the optional field `assessment_proposal`
        if (data['assessment_proposal']) { // data not null
          AssessmentProposal.validateJSON(data['assessment_proposal']);
        }
        // validate the optional field `user_proposal`
        if (data['user_proposal']) { // data not null
          UserProposal.validateJSON(data['user_proposal']);
        }
        // ensure the json data is a string
        if (data['user_matching_type'] && !(typeof data['user_matching_type'] === 'string' || data['user_matching_type'] instanceof String)) {
            throw new Error("Expected the field `user_matching_type` to be a primitive type in the JSON string but got " + data['user_matching_type']);
        }
        // ensure the json data is a string
        if (data['progress'] && !(typeof data['progress'] === 'string' || data['progress'] instanceof String)) {
            throw new Error("Expected the field `progress` to be a primitive type in the JSON string but got " + data['progress']);
        }

        return true;
    }


}



/**
 * @member {Number} id
 */
ProposalMatching.prototype['id'] = undefined;

/**
 * @member {Date} discarded_at
 */
ProposalMatching.prototype['discarded_at'] = undefined;

/**
 * @member {Boolean} is_invalid
 */
ProposalMatching.prototype['is_invalid'] = undefined;

/**
 * @member {Number} agent_id
 */
ProposalMatching.prototype['agent_id'] = undefined;

/**
 * @member {Number} user_id
 */
ProposalMatching.prototype['user_id'] = undefined;

/**
 * @member {Number} assessment_proposal_id
 */
ProposalMatching.prototype['assessment_proposal_id'] = undefined;

/**
 * @member {Number} investment_proposal_id
 */
ProposalMatching.prototype['investment_proposal_id'] = undefined;

/**
 * @member {Boolean} is_manual_match
 */
ProposalMatching.prototype['is_manual_match'] = undefined;

/**
 * @member {Boolean} is_agent_read
 */
ProposalMatching.prototype['is_agent_read'] = undefined;

/**
 * @member {Date} created_at
 */
ProposalMatching.prototype['created_at'] = undefined;

/**
 * @member {Date} updated_at
 */
ProposalMatching.prototype['updated_at'] = undefined;

/**
 * @member {Date} user_registered_at
 */
ProposalMatching.prototype['user_registered_at'] = undefined;

/**
 * 第一希望日
 * @member {Date} first_preferred_contact_date
 */
ProposalMatching.prototype['first_preferred_contact_date'] = undefined;

/**
 * 第一希望時間帯
 * @member {module:model/ProposalMatching.FirstPreferredContactTimeSlotEnum} first_preferred_contact_time_slot
 */
ProposalMatching.prototype['first_preferred_contact_time_slot'] = undefined;

/**
 * 第二希望日
 * @member {Date} second_preferred_contact_date
 */
ProposalMatching.prototype['second_preferred_contact_date'] = undefined;

/**
 * 第二希望時間帯
 * @member {module:model/ProposalMatching.SecondPreferredContactTimeSlotEnum} second_preferred_contact_time_slot
 */
ProposalMatching.prototype['second_preferred_contact_time_slot'] = undefined;

/**
 * @member {module:model/Agent} agent
 */
ProposalMatching.prototype['agent'] = undefined;

/**
 * @member {module:model/User} user
 */
ProposalMatching.prototype['user'] = undefined;

/**
 * @member {module:model/InvestmentProposal} investment_proposal
 */
ProposalMatching.prototype['investment_proposal'] = undefined;

/**
 * @member {module:model/AssessmentProposal} assessment_proposal
 */
ProposalMatching.prototype['assessment_proposal'] = undefined;

/**
 * @member {module:model/UserProposal} user_proposal
 */
ProposalMatching.prototype['user_proposal'] = undefined;

/**
 * 対象ユーザの成約申請済みが1件以上あるかどうか
 * @member {Boolean} is_contract_applied
 */
ProposalMatching.prototype['is_contract_applied'] = undefined;

/**
 * @member {module:model/MatchingType} matching_type
 */
ProposalMatching.prototype['matching_type'] = undefined;

/**
 * ユーザーマッチ時の内訳（プロ検索 or 限定物件）
 * @member {String} user_matching_type
 */
ProposalMatching.prototype['user_matching_type'] = undefined;

/**
 * @member {Number} matching_counts
 */
ProposalMatching.prototype['matching_counts'] = undefined;

/**
 * 累計マッチ数の合計
 * @member {Number} matched_count_sum
 */
ProposalMatching.prototype['matched_count_sum'] = undefined;

/**
 * マッチ種別「ユーザ」の累計マッチ数
 * @member {Number} matched_count_user
 */
ProposalMatching.prototype['matched_count_user'] = undefined;

/**
 * マッチ種別「投資」の累計マッチ数
 * @member {Number} matched_count_investment
 */
ProposalMatching.prototype['matched_count_investment'] = undefined;

/**
 * マッチ種別「査定」の累計マッチ数
 * @member {Number} matched_count_assessment
 */
ProposalMatching.prototype['matched_count_assessment'] = undefined;

/**
 * マッチ種別「手動」の累計マッチ数
 * @member {Number} matched_count_manual
 */
ProposalMatching.prototype['matched_count_manual'] = undefined;

/**
 * @member {module:model/SalesNoteProspectLankEnum} prospect_lank
 */
ProposalMatching.prototype['prospect_lank'] = undefined;

/**
 * @member {module:model/SalesNoteStatusEnum} status
 */
ProposalMatching.prototype['status'] = undefined;

/**
 * @member {module:model/SalesNoteCompleteReasonEnum} complete_reason
 */
ProposalMatching.prototype['complete_reason'] = undefined;

/**
 * @member {String} progress
 */
ProposalMatching.prototype['progress'] = undefined;

/**
 * アポ取得ボタンで登録した最新のアポ日
 * @member {Date} appointment_date
 */
ProposalMatching.prototype['appointment_date'] = undefined;

/**
 * 進捗メモの最終更新日時（楽観的排他制御用）
 * @member {Date} sales_note_updated_at
 */
ProposalMatching.prototype['sales_note_updated_at'] = undefined;

/**
 * @member {module:model/UserOfferSourceCategoryEnum} user_offer_source_category
 */
ProposalMatching.prototype['user_offer_source_category'] = undefined;

/**
 * @member {module:model/UserOfferSourceAnalysisItemSourceEnum} user_offer_source
 */
ProposalMatching.prototype['user_offer_source'] = undefined;

/**
 * 学習コンテンツ既読数
 * @member {Number} learning_completed_count
 */
ProposalMatching.prototype['learning_completed_count'] = undefined;

/**
 * 学習進捗率（既読数/全記事数）
 * @member {Number} learning_progress_rate
 */
ProposalMatching.prototype['learning_progress_rate'] = undefined;

/**
 * エージェントの対象条件に合致しているか
 * @member {Boolean} is_target
 */
ProposalMatching.prototype['is_target'] = undefined;





/**
 * Allowed values for the <code>first_preferred_contact_time_slot</code> property.
 * @enum {String}
 * @readonly
 */
ProposalMatching['FirstPreferredContactTimeSlotEnum'] = {

    /**
     * value: "morning"
     * @const
     */
    "morning": "morning",

    /**
     * value: "afternoon"
     * @const
     */
    "afternoon": "afternoon",

    /**
     * value: "evening"
     * @const
     */
    "evening": "evening",

    /**
     * value: "slot_9_11"
     * @const
     */
    "slot_9_11": "slot_9_11",

    /**
     * value: "slot_11_13"
     * @const
     */
    "slot_11_13": "slot_11_13",

    /**
     * value: "slot_13_15"
     * @const
     */
    "slot_13_15": "slot_13_15",

    /**
     * value: "slot_15_17"
     * @const
     */
    "slot_15_17": "slot_15_17",

    /**
     * value: "slot_17_19"
     * @const
     */
    "slot_17_19": "slot_17_19",

    /**
     * value: "slot_19_21"
     * @const
     */
    "slot_19_21": "slot_19_21"
};


/**
 * Allowed values for the <code>second_preferred_contact_time_slot</code> property.
 * @enum {String}
 * @readonly
 */
ProposalMatching['SecondPreferredContactTimeSlotEnum'] = {

    /**
     * value: "morning"
     * @const
     */
    "morning": "morning",

    /**
     * value: "afternoon"
     * @const
     */
    "afternoon": "afternoon",

    /**
     * value: "evening"
     * @const
     */
    "evening": "evening",

    /**
     * value: "slot_9_11"
     * @const
     */
    "slot_9_11": "slot_9_11",

    /**
     * value: "slot_11_13"
     * @const
     */
    "slot_11_13": "slot_11_13",

    /**
     * value: "slot_13_15"
     * @const
     */
    "slot_13_15": "slot_13_15",

    /**
     * value: "slot_15_17"
     * @const
     */
    "slot_15_17": "slot_15_17",

    /**
     * value: "slot_17_19"
     * @const
     */
    "slot_17_19": "slot_17_19",

    /**
     * value: "slot_19_21"
     * @const
     */
    "slot_19_21": "slot_19_21"
};



export default ProposalMatching;

